export default function (request) {
  const prefix = process.env.VUE_APP_STATS_SERVER

  return {
    /**
     * 获取用户关键词排名趋势
     */
    getUserKeywordRankTrend ({ query }) {
      return request({
        url: `${prefix}/user_ranking_trend`,
        method: 'get',
        params: query
      })
    },

    /**
     * 获取用户发布量趋势
     */
    getUserPublishTrend ({ query }) {
      return request({
        url: `${prefix}/article_publish_trend`,
        method: 'get',
        params: query
      })
    }

  }
}
